import style from './TaskPreloader.module.scss';

import { Preloader } from '@components/Preloader';

export function TaskPreloader(): React.ReactElement<any> {
    return (
        <div className={style.preloader}>
            <Preloader />
        </div>
    );
}
